import RefNavbar from './RefNavbar';
import RefPrivacy from './RefPrivacy';

function Page2026Privacy() {
  return (
    <>
      <RefNavbar />
      <RefPrivacy />
    </>
  );
}

export default Page2026Privacy;
